import { Autocomplete, AutocompleteProps, TextField } from "@mui/material";
import {
  Control,
  Controller,
  FieldValues,
  Path,
  RegisterOptions,
} from "react-hook-form";

interface FormSelectFieldProps<T extends FieldValues>
  extends Omit<
    AutocompleteProps<string, false, false, true>,
    "error" | "onChange" | "required" | "renderInput"
  > {
  name: Path<T>;
  control: Control<T>;
  options: any[];
  label?: string;
  rules?: RegisterOptions<T>;
  handleChange?: (e: any, fieldOnChange: (e: any) => void) => void;
}

const FormSelectField = <T extends FieldValues>({
  name,
  options,
  control,
  label,
  rules = {},
  handleChange,
  ...rest
}: FormSelectFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { value, onChange, onBlur, ref },
        fieldState: { error },
      }) => {
        return (
          <Autocomplete
            onBlur={onBlur}
            value={value}
            ref={ref}
            onChange={(e, value) =>
              handleChange ? handleChange(value, onChange) : onChange(value)
            }
            options={options}
            renderInput={(params) => (
              <TextField
                {...params}
                error={Boolean(error)}
                label={label}
                helperText={error ? error.message : ""}
              />
            )}
            {...rest}
          />
        );
      }}
    />
  );
};

export default FormSelectField;
